import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../app/core/guards/auth.guard';
import { IsVerifiedAccountStateGuard } from '../../../app/core/guards/is-verified-account-state.guard';
import { VerifyAccountStateGuard } from '../../../app/core/guards/verify-account-state.guard';
import { LayoutComponent } from './layout/layout.component';
import { AccountActivationComponent } from './pages/auth/account-activation/account-activation.component';
import { ForgetPasswordComponent } from './pages/auth/forget-password/forget-password.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { PermissionComponent } from './pages/auth/permission/permission.component';
import { ProfileComponent } from './pages/auth/profile/profile.component';
import { RecoveryPasswordComponent } from './pages/auth/recovery-password/recovery-password.component';
import { RoleComponent } from './pages/auth/role/role.component';
import { UserProfilComponent } from './pages/auth/user-profil/user-profil.component';

import { HomeComponent } from './pages/home/home.component';
import { UserComponent } from './pages/user/user.component';
import { CountryComponent } from './pages/configurations/country/country.component';
import { FinancialComponent } from './pages/financial/financial.component';
import { ApplicationComponent } from './pages/application/application.component';
import { ItemComponent } from './pages/item/item.component';
import { BoostageComponent } from './pages/boostage/boostage.component';
import { TarificationComponent } from './pages/tarification/tarification.component';
import { DeliveryComponent } from './pages/delivery/delivery.component';
import { CategoryComponent } from './pages/category/category.component';
import { ParainageComponent } from './pages/parainage/parainage.component';
import { StoreComponent } from './pages/store/store.component';
import { SubscriptionComponent } from './pages/subscription/subscription.component';
import { InfluencerComponent } from './pages/influencer/influencer.component';
import { VideoComponent } from './pages/video/video.component';
import { DeliverComponent } from './pages/deliver/deliver.component';
import { RetraitComponent } from './pages/retrait/retrait.component';
import { TranfertComponent } from './pages/tranfert/tranfert.component';
import { DepositComponent } from './pages/deposit/deposit.component';
import { TransactionComponent } from './pages/transaction/transaction.component';
import { CvthequeComponent } from './pages/cvtheque/cvtheque.component';
import { ProviderComponent } from './pages/provider/provider.component';
import { RequestComponent } from './pages/request/request.component';
import { CourseComponent } from './pages/course/course.component';
import { TransactionFeeComponent } from './pages/transaction-fee/transaction-fee.component';
import { OrderComponent } from './pages/order/order.component';
import { ParainageDetailsComponent } from './pages/parainage-details/parainage-details.component';
import { ServiceMgmtComponent } from './pages/service-mgmt/service-mgmt.component';
import { CarReservationComponent } from './pages/car-reservation/car-reservation.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { PressingComponent } from './pages/pressing/pressing.component';

export const AdminRoutes: any = 
  {
    path: '',
    component:LayoutComponent,
    canActivate:[AuthGuard,VerifyAccountStateGuard],
    children:[
      {
        path:"dashboard",
        component:HomeComponent
      },

      {
        path:"countries",
        component:CountryComponent
      },
      {
        path:"financials",
        component:FinancialComponent
      },
      {
        path:"applications",
        component:ApplicationComponent
      },
      {
        path:"items",
        component:ItemComponent
      },
      {
        path:"boosts",
        component:BoostageComponent
      },
      {
        path:"tarifications",
        component:TarificationComponent
      },
      {
        path:"delivers",
        component:DeliverComponent
      },
      {
        path:"categories",
        component:CategoryComponent
      },
      {
        path:"sponsorships",
        component:ParainageComponent
      },
      {
        path:"sponsorships-details/:referalId",
        component:ParainageDetailsComponent
      },
      {
        path:"deliveries",
        component:DeliveryComponent
      },
      {
        path:"stores",
        component:StoreComponent
      },
      {
        path:"subscriptions",
        component:SubscriptionComponent
      },
      {
        path:"influencers",
        component:InfluencerComponent
      },
      {
        path:"videos",
        component:VideoComponent
      },
      {
        path:"orders",
        component:OrderComponent
      },
      {
        path:"deposits",
        component:DepositComponent
      },
      {
        path:"transactions",
        component:TransactionComponent
      },
      {
        path:"transaction-fees",
        component:TransactionFeeComponent
      },
      {
        path:"cvs",
        component:CvthequeComponent
      },
      {
        path:"providers",
        component:ProviderComponent
      },
      {
        path:"requests",
        component:RequestComponent
      },
      {
        path:"services",
        component:ServiceMgmtComponent
      },
      {
        path:"courses",
        component:CourseComponent
      },
      {
        path:"car-reservations",
        component:CarReservationComponent
      },
      {
        path:"notifications",
        component:NotificationComponent
      },
      {
        path:"pressing",
        component:PressingComponent
      },
      {
        path:"transferts",
        component:TranfertComponent
      },
      {
        path:"withdrawals",
        component:RetraitComponent
      },
      {
        path:"configurations/countries",
        component:CountryComponent
      },
      //settings
      {
        path:"users",
        component:UserComponent
      },
      {
        path:"roles",
        component:RoleComponent
      },
      {
        path:"permissions",
        component:PermissionComponent
      },
      {
        path:"profiles",
        component:ProfileComponent
      },
      {
        path:"user-account",
        component:UserProfilComponent
      }
    ]
  };


